<template>
    <div
            class="player-container"
    >
        <Component
                :is="driverComponent"
                :data="video.player_data"
                @videoStarted="videoStartedHandler"
                @videoEnded="videoEndedHandler"
                :poster="movie.public_thumbnail_image_path['large']"
                :title="movie.name"
                :subtitle="movie.description"
        />
        <div
                class="overlay"
                :class="{visible: showOverlay}"
        >
            <slot name="overlay"/>
        </div>
    </div>
</template>
<script>
    import ErrorPlayer from './VideoPlayer.Error';
    /*
    import LoadingPlayer from './VideoPlayer.Loading';

    const generatePlayerComponent = () => ({
        component: import(path),
        loading: LoadingPlayer,
        error: ErrorPlayer,
        delay: 200,
        timeout: 3000,
    });*/

    export default {
        components: {
            //DemoPlayer: () => import('./VideoPlayer.Demo'),
            ErrorPlayer,
            ChunkedPlayer: () => import('./VideoPlayer.Chunked'),
        },
        props: {
            video: {
                type: Object,
                required: true,
            },
            showOverlay:{
                type: Boolean,
                required: false,
                default: false
            },
            movie: {
                type: Object,
                required: true
            }
        },
        data(){
            return {

            }
        },
        computed: {
            driverComponent(){
                switch(this.video.encode_driver) {
                    case 'pro_chunked':     return 'ChunkedPlayer';
                    case 'trailer_chunked': return 'ChunkedPlayer';
                    case 'free_chunked':    return 'ChunkedPlayer';
                    case 'cloudflare':      return 'ChunkedPlayer';

                    default: return 'ErrorPlayer';
                }
            },
        },
        mounted(){

        },
        watch: {
            driverComponent(val){
                // console.log(val);
                if(val === 'ErrorPlayer'){
                    console.error(`No se reconoce el player: ${this.video.encode_driver}`);
                }
            }
        },
        methods: {
            videoEndedHandler(){
                this.$emit('videoEnded', this.video);
            },
            videoStartedHandler(){
                this.$emit('videoStarted', this.video);
            },
        },
    }
</script>

<style scoped lang="scss">
    .player-wrapper {
        width: 100%;
        .player{
            width: 100%;
            height: 500px;
        }
    }

    .player-container{
        position: relative;

        .corner{
            position: absolute;
            z-index: 10;
            top: 0;
            right: 0;
            width: auto;
            height: auto;
        }

        .overlay{
            display: none;
            color: #ffffff;
            z-index:9;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            &.visible{
                display:block;
            }
        }
    }
</style>
<style lang="scss">
    .vjs-menu-button-popup.active{
        .vjs-menu{
            display: block;
        }
    }
</style>